export default __webpack_public_path__ + "static/media/category-4.f3071039.webp";